module.exports = __webpack_public_path__ + "img/ednextlogo.95e4477c.jpeg";